module.exports = __webpack_public_path__ + "static/media/ACHIOTE_B_3.2566b0fa.png";